// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Uuid from "../../externals/Uuid.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as DropZone from "../../resources/selection-and-input/DropZone.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as FilePicker from "../../primitives/FilePicker.res.js";
import * as HelpCenter from "../../core/HelpCenter.res.js";
import * as IconButton from "../../resources/actions/IconButton.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as TextAction from "../../resources/actions/TextAction.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Stdlib_Math from "@rescript/runtime/lib/es6/Stdlib_Math.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as InputDateField from "../../resources/selection-and-input/InputDateField.res.js";
import * as InputTimeField from "../../resources/selection-and-input/InputTimeField.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateReducer from "../../primitives/ReactUpdateReducer.res.js";
import * as StockActivityRoutes from "../StockActivity/StockActivityRoutes.res.js";
import * as InputToggleSwitchField from "../../resources/selection-and-input/InputToggleSwitchField.res.js";
import * as CatalogInventoryImportSheet from "../../modules/Catalog/CatalogInventoryImportSheet.res.js";
let endpoint = Env.gatewayUrl() + "/inventory-import/audit";
function encodeBodyJson(inventoryItems) {
  let dict = {};
  dict["inventoryItems"] = Json.encodeArray(inventoryItems.map(item => {
    let dict = {};
    dict["variantId"] = Json.encodeString(item.variantId);
    dict["stock"] = Json.encodeNumber(item.stock);
    return Json.encodeDict(dict);
  }));
  return dict;
}
function decodeInvalidRequestFailureDataVariantId(json) {
  return Stdlib_Option.flatMap(Stdlib_Option.orElse(Json.flatDecodeDictFieldString(Json.decodeDict(json), "id"), Json.flatDecodeDictFieldString(Json.decodeDict(json), "variantId")), Uuid.fromString);
}
function decodeInvalidRequestFailure(serverFailure) {
  let variantId = Stdlib_Option.flatMap(serverFailure.data, decodeInvalidRequestFailureDataVariantId);
  if (variantId === undefined) {
    return "Unknown";
  }
  let variantId$1 = Primitive_option.valFromOption(variantId);
  let match = serverFailure.kind;
  switch (match) {
    case "DuplicateVariantIdFailure":
      return {
        TAG: "DuplicateVariantId",
        _0: variantId$1
      };
    case "InsufficientCapacityPrecision":
      return {
        TAG: "InvalidCapacityPrecision",
        _0: variantId$1
      };
    case "NotFoundVariant":
      return {
        TAG: "NotFoundVariant",
        _0: variantId$1
      };
    case "OutOfRangeStockValue":
      return {
        TAG: "OutOfRangeStockValue",
        _0: variantId$1
      };
    case "VariantBulkStockValue":
      return {
        TAG: "NotBulkProduct",
        _0: variantId$1
      };
    default:
      return "Unknown";
  }
}
function decodeError(error) {
  if (typeof error !== "object") {
    return ["Unknown"];
  }
  if (error.TAG !== "InvalidRequestFailures") {
    return ["Unknown"];
  }
  let invalidRequestFailure = error._0;
  if (invalidRequestFailure.length !== 0) {
    return invalidRequestFailure.map(decodeInvalidRequestFailure);
  } else {
    return ["Unknown"];
  }
}
function make(inventoryItems) {
  return Future.mapError(Future.mapOk(Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeBodyJson(inventoryItems)
  }, undefined, undefined), undefined, param => {}), undefined, decodeError);
}
let CatalogInventoryAuditRequest = {
  endpoint: endpoint,
  encodeBodyJson: encodeBodyJson,
  decodeInvalidRequestFailureDataVariantId: decodeInvalidRequestFailureDataVariantId,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  decodeError: decodeError,
  make: make
};
let endpoint$1 = Env.gatewayUrl() + "/inventory-import";
function encodeBodyJson$1(inventoryItems, inventoryDatetime, param) {
  let dict = {};
  dict["inventoryItems"] = Json.encodeArray(inventoryItems.map(item => {
    let dict = {};
    dict["variantId"] = Json.encodeString(item.variantId);
    dict["stock"] = Json.encodeNumber(item.stock);
    return Json.encodeDict(dict);
  }));
  if (inventoryDatetime !== undefined) {
    let timestamp = inventoryDatetime.getTime();
    dict["inventoryDate"] = Json.encodeNumber(timestamp);
  }
  return dict;
}
function make$1(inventoryItems, inventoryDatetime, param) {
  return Request.make(endpoint$1, "POST", {
    TAG: "JsonBody",
    _0: encodeBodyJson$1(inventoryItems, inventoryDatetime, undefined)
  }, undefined, true);
}
let CatalogInventoryImportRequest = {
  endpoint: endpoint$1,
  encodeBodyJson: encodeBodyJson$1,
  make: make$1
};
function CatalogInventoryImportPage$CatalogInventoryImportPickFileView(props) {
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsxs(InlineText.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Before upload your files below, make sure "),
          variation: "normal"
        }), JsxRuntime.jsx(TextAction.make, {
          text: I18n.t("your file is ready to be imported."),
          highlighted: true,
          onPress: () => HelpCenter.showArticle(HelpCenter.prepareImportInventory)
        })],
        align: "center"
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Drag and drop or choose a file to upload the inventory."),
        align: "center",
        variation: "normal"
      })]
    }), JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(FilePicker.make, {
        children: JsxRuntime.jsx(Button.make, {
          label: I18n.t("Pick file"),
          pending: props.loading
        }),
        types: CatalogInventoryImportSheet.fileTypes,
        maxSizeMb: 10,
        onChange: props.onPickSuccess,
        onError: props.onPickError
      }),
      align: "center"
    })],
    space: "medium"
  });
}
let CatalogInventoryImportPickFileView = {
  make: CatalogInventoryImportPage$CatalogInventoryImportPickFileView
};
function CatalogInventoryImportPage$CatalogInventoryImportLaunchImportView(props) {
  let onFileClear = props.onFileClear;
  let rowsCount = props.rowsCount;
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("File is ready to be imported:") + " "
      }), JsxRuntime.jsx(TextStyle.make, {
        children: I18n.template(I18n.t("{{stockCount}} {{stocksPlural}} quantity to be updated"), {
          stockCount: rowsCount,
          stocksPlural: rowsCount > 1 ? I18n.t("stocks") + " " + I18n.t("are") : I18n.t("stock") + " " + I18n.t("is")
        }, undefined),
        variation: "secondary",
        weight: "medium"
      })],
      align: "center"
    }), JsxRuntime.jsxs(Inline.make, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("File to import:"),
        variation: "normal",
        size: "small"
      }), JsxRuntime.jsx(TextStyle.make, {
        children: " " + props.filename,
        weight: "medium",
        size: "small"
      }), onFileClear !== undefined ? JsxRuntime.jsx(IconButton.make, {
        name: "close_medium",
        onPress: param => onFileClear()
      }) : null],
      space: "xsmall",
      align: "center"
    })]
  });
}
let CatalogInventoryImportLaunchImportView = {
  make: CatalogInventoryImportPage$CatalogInventoryImportLaunchImportView
};
function CatalogInventoryImportPage$CatalogInventoryImportSuccessImportView(props) {
  let rowsCount = props.rowsCount;
  let navigate = Navigation.useNavigate();
  let onPressViewButton = param => navigate(undefined, StockActivityRoutes.baseRoute);
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(TextStyle.make, {
        children: I18n.template(I18n.t("{{stockCount}} {{stocksPlural}} quantity {{haveBeenPlural}} updated in your catalog"), {
          stockCount: rowsCount,
          stocksPlural: rowsCount > 1 ? I18n.t("stocks") : I18n.t("stock"),
          haveBeenPlural: rowsCount > 1 ? I18n.t("have been") : I18n.t("has been")
        }, undefined),
        align: "center",
        variation: "success",
        weight: "medium"
      }), JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("Imported file:"),
          variation: "normal",
          size: "small"
        }), JsxRuntime.jsx(TextStyle.make, {
          children: " " + props.filename,
          weight: "medium",
          size: "small"
        })],
        space: "xsmall",
        align: "center"
      })]
    }), JsxRuntime.jsx(Inline.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("View stock activities"),
        onPress: onPressViewButton
      }),
      align: "center"
    })],
    space: "medium"
  });
}
let CatalogInventoryImportSuccessImportView = {
  make: CatalogInventoryImportPage$CatalogInventoryImportSuccessImportView
};
let initialState = {
  TAG: "Audit",
  _0: "NotAsked"
};
let CatalogInventoryImportFileState = {
  initialState: initialState
};
let initialState$1 = {
  enabled: false,
  edited: false,
  errorMessage: undefined,
  value: undefined
};
let CatalogInventoryImportDatetimeState = {
  initialState: initialState$1
};
function validateDatetimeState(state) {
  if (!state.enabled) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  if (!state.edited) {
    return {
      TAG: "Error",
      _0: I18n.t("Required field")
    };
  }
  let datetime = state.value;
  if (datetime === undefined) {
    return {
      TAG: "Error",
      _0: I18n.t("Required field")
    };
  }
  let now = new Date();
  let validated = datetime.getTime() <= now.getTime();
  if (validated) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return {
      TAG: "Error",
      _0: I18n.t("The time must be earlier")
    };
  }
}
let initialState$2 = {
  submitted: false,
  errored: false,
  notification: undefined,
  sheetFile: undefined,
  fileState: initialState,
  datetimeState: initialState$1
};
function reducer(state, action) {
  if (typeof action !== "object") {
    switch (action) {
      case "ResetRequested":
        return {
          TAG: "Update",
          _0: {
            submitted: false,
            errored: false,
            notification: undefined,
            sheetFile: undefined,
            fileState: initialState,
            datetimeState: initialState$1
          }
        };
      case "DatetimeValidationRequested":
        let validated = validateDatetimeState(state.datetimeState);
        let errorMessage;
        errorMessage = validated.TAG === "Ok" ? undefined : validated._0;
        let init = state.datetimeState;
        let datetimeState_enabled = init.enabled;
        let datetimeState_edited = init.edited;
        let datetimeState_value = init.value;
        let datetimeState = {
          enabled: datetimeState_enabled,
          edited: datetimeState_edited,
          errorMessage: errorMessage,
          value: datetimeState_value
        };
        return {
          TAG: "Update",
          _0: {
            submitted: false,
            errored: state.errored,
            notification: state.notification,
            sheetFile: state.sheetFile,
            fileState: state.fileState,
            datetimeState: datetimeState
          }
        };
      case "ValidationRequested":
        let validated$1 = validateDatetimeState(state.datetimeState);
        let errored = Stdlib_Result.isError(validated$1);
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            submitted: true,
            errored: errored,
            notification: state.notification,
            sheetFile: state.sheetFile,
            fileState: state.fileState,
            datetimeState: state.datetimeState
          },
          _1: self => {
            let errorNotificationText_textStatus = {
              TAG: "Danger",
              _0: I18n.t("There are some errors in the form, please correct them before trying to send it again.")
            };
            let errorNotificationText = {
              textStatus: errorNotificationText_textStatus
            };
            if (errored) {
              self.dispatch("DatetimeValidationRequested");
              self.dispatch({
                TAG: "SetNotificationRequested",
                _0: errorNotificationText
              });
            } else {
              self.dispatch({
                TAG: "SetFileProcessed",
                _0: {
                  TAG: "Import",
                  _0: "Loading"
                }
              });
            }
          }
        };
    }
  } else {
    switch (action.TAG) {
      case "SetNotificationRequested":
        return {
          TAG: "Update",
          _0: {
            submitted: state.submitted,
            errored: state.errored,
            notification: action._0,
            sheetFile: state.sheetFile,
            fileState: state.fileState,
            datetimeState: state.datetimeState
          }
        };
      case "ImportSubmitted":
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            submitted: state.submitted,
            errored: state.errored,
            notification: state.notification,
            sheetFile: action._0,
            fileState: state.fileState,
            datetimeState: state.datetimeState
          },
          _1: param => {
            param.dispatch("ValidationRequested");
          }
        };
      case "SetFileProcessed":
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            submitted: state.submitted,
            errored: state.errored,
            notification: state.notification,
            sheetFile: state.sheetFile,
            fileState: action._0,
            datetimeState: state.datetimeState
          },
          _1: self => {
            let match = self.state.fileState;
            let notification;
            if (match.TAG === "Audit") {
              let match$1 = match._0;
              if (typeof match$1 !== "object" || match$1.TAG !== "Done") {
                notification = undefined;
              } else {
                let error = match$1._0;
                if (error.TAG === "Ok") {
                  notification = {
                    textStatus: {
                      TAG: "Info",
                      _0: I18n.t("The inventory file is ready. Click on \"Launch import\" to import your file.")
                    }
                  };
                } else {
                  let error$1 = error._0;
                  self.dispatch("ResetRequested");
                  let exit = 0;
                  let errorMessages;
                  switch (error$1.TAG) {
                    case "ParseDecodeError":
                      notification = {
                        textStatus: {
                          TAG: "Danger",
                          _0: error$1._0
                        }
                      };
                      break;
                    case "MultipleParseDecodeErrors":
                      errorMessages = error$1._0;
                      exit = 1;
                      break;
                    case "ServerError":
                      let errorMessages$1 = error$1._0;
                      if (typeof errorMessages$1 !== "object") {
                        notification = {
                          textStatus: {
                            TAG: "Danger",
                            _0: I18n.t("Wino could not proceed to the inventory import, please try again.")
                          }
                        };
                      } else {
                        errorMessages = errorMessages$1._0;
                        exit = 1;
                      }
                      break;
                  }
                  if (exit === 1) {
                    notification = {
                      textStatus: {
                        TAG: "Danger",
                        _0: I18n.t("The inventory file is incorrect and cannot be processed, several data items are incorrect.")
                      },
                      details: errorMessages
                    };
                  }
                }
              }
            } else {
              let match$2 = match._0;
              if (typeof match$2 !== "object" || match$2.TAG !== "Done") {
                notification = undefined;
              } else if (match$2._0.TAG === "Ok") {
                notification = {
                  textStatus: {
                    TAG: "Success",
                    _0: I18n.t("The inventory file has been successfully imported! Please wait a few minutes before synchronizing your iPads.")
                  }
                };
              } else {
                self.dispatch("ResetRequested");
                notification = {
                  textStatus: {
                    TAG: "Danger",
                    _0: I18n.t("Wino could not proceed to the inventory import, please try again.")
                  }
                };
              }
            }
            self.dispatch({
              TAG: "SetNotificationRequested",
              _0: notification
            });
          }
        };
      case "BackdateToggled":
        let enabled = action._0;
        let defaultDatetime = enabled ? new Date() : undefined;
        let datetimeState$1 = {
          enabled: enabled,
          edited: false,
          errorMessage: undefined,
          value: defaultDatetime
        };
        return {
          TAG: "Update",
          _0: {
            submitted: state.submitted,
            errored: state.errored,
            notification: state.notification,
            sheetFile: state.sheetFile,
            fileState: state.fileState,
            datetimeState: datetimeState$1
          }
        };
      case "DateUpdated":
        let nextDate = action._0;
        let date = Stdlib_Option.getOr(state.datetimeState.value, new Date());
        let nextDate$1 = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate(), date.getHours(), date.getMinutes());
        let init$1 = state.datetimeState;
        let datetimeState_enabled$1 = init$1.enabled;
        let datetimeState_edited$1 = init$1.edited;
        let datetimeState_errorMessage = init$1.errorMessage;
        let datetimeState_value$1 = nextDate$1;
        let datetimeState$2 = {
          enabled: datetimeState_enabled$1,
          edited: datetimeState_edited$1,
          errorMessage: datetimeState_errorMessage,
          value: datetimeState_value$1
        };
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            submitted: state.submitted,
            errored: state.errored,
            notification: state.notification,
            sheetFile: state.sheetFile,
            fileState: state.fileState,
            datetimeState: datetimeState$2
          },
          _1: self => {
            if (self.state.datetimeState.edited) {
              self.dispatch("DatetimeValidationRequested");
            }
          }
        };
      case "DatetimeUpdated":
        let nextDatetime = action._0;
        let date$1 = Stdlib_Option.getOr(state.datetimeState.value, new Date());
        let datetime = new Date(date$1.getFullYear(), date$1.getMonth(), date$1.getDate(), nextDatetime.getHours(), nextDatetime.getMinutes());
        let init$2 = state.datetimeState;
        let datetimeState_enabled$2 = init$2.enabled;
        let datetimeState_errorMessage$1 = init$2.errorMessage;
        let datetimeState_value$2 = datetime;
        let datetimeState$3 = {
          enabled: datetimeState_enabled$2,
          edited: true,
          errorMessage: datetimeState_errorMessage$1,
          value: datetimeState_value$2
        };
        return {
          TAG: "UpdateWithSideEffects",
          _0: {
            submitted: state.submitted,
            errored: state.errored,
            notification: state.notification,
            sheetFile: state.sheetFile,
            fileState: state.fileState,
            datetimeState: datetimeState$3
          },
          _1: self => {
            self.dispatch("DatetimeValidationRequested");
          }
        };
    }
  }
}
let CatalogInventoryImportReducer = {
  validateDatetimeState: validateDatetimeState,
  initialState: initialState$2,
  reducer: reducer
};
let styles = {
  root: {
    "backgroundColor-kWkggS": "backgroundColor-x1srn7af",
    "borderColor-kVAM5u": "borderColor-x1fs2082",
    "borderRadius-kaIpWk": "borderRadius-x1sxf85j",
    "borderStyle-ksu8eU": "borderStyle-x1y0btm7",
    "borderWidth-kMzoRj": "borderWidth-xmkeg23",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "padding-kmVPX3": "padding-x10xs6qf",
    $$css: "wino-gc:src/app/Catalog/CatalogInventoryImportPage.res.js:669"
  }
};
function CatalogInventoryImportPage$CatalogInventoryImportFileCard(props) {
  let onRejectFile = props.onRejectFile;
  let onAcceptFile = props.onAcceptFile;
  let state = props.state;
  let dropFileDisabled;
  if (state.TAG === "Audit") {
    let tmp = state._0;
    dropFileDisabled = typeof tmp !== "object" ? tmp !== "NotAsked" : true;
  } else {
    let match = state._0;
    dropFileDisabled = typeof match !== "object" || match.TAG !== "Done" ? true : match._0.TAG !== "Ok";
  }
  let newrecord = {
    ...{
      className: "backgroundColor-x1srn7af borderColor-x1fs2082 borderRadius-x1sxf85j borderStyle-x1y0btm7 borderWidth-xmkeg23 alignItems-x6s0dn4 justifyContent-xl56j7k padding-x10xs6qf",
      "data-style-src": "wino-gc:src/app/Catalog/CatalogInventoryImportPage.res.js:669"
    }
  };
  let tmp$1;
  if (state.TAG === "Audit") {
    let asyncResult = state._0;
    let exit = 0;
    if (typeof asyncResult !== "object") {
      exit = 1;
    } else if (asyncResult.TAG === "Reloading") {
      tmp$1 = null;
    } else {
      let match$1 = asyncResult._0;
      if (match$1.TAG === "Ok") {
        let match$2 = match$1._0;
        tmp$1 = JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportLaunchImportView, {
          filename: match$2.filename,
          rowsCount: match$2.data.length,
          onFileClear: props.onResetPress
        });
      } else {
        tmp$1 = null;
      }
    }
    if (exit === 1) {
      let loading = AsyncResult.isBusy(asyncResult);
      tmp$1 = JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportPickFileView, {
        loading: loading,
        onPickSuccess: onAcceptFile,
        onPickError: onRejectFile
      });
    }
  } else {
    let match$3 = state._0;
    let exit$1 = 0;
    if (typeof match$3 !== "object") {
      if (match$3 === "NotAsked") {
        tmp$1 = null;
      } else {
        exit$1 = 1;
      }
    } else if (match$3.TAG === "Reloading") {
      exit$1 = 1;
    } else {
      let match$4 = match$3._0;
      if (match$4.TAG === "Ok") {
        let match$5 = match$4._0;
        tmp$1 = JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportSuccessImportView, {
          filename: match$5.filename,
          rowsCount: match$5.data.length
        });
      } else {
        tmp$1 = null;
      }
    }
    if (exit$1 === 1) {
      let match$6 = Stdlib_Option.mapOr(props.sheetFile, ["?", []], payload => [payload.filename, payload.data]);
      tmp$1 = JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportLaunchImportView, {
        filename: match$6[0],
        rowsCount: match$6[1].length
      });
    }
  }
  newrecord.children = tmp$1;
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(DropZone.make, {
      children: JsxRuntime.jsx("div", newrecord),
      customSubtitle: I18n.t("to validate it then to import it"),
      types: CatalogInventoryImportSheet.fileTypes,
      maxSizeMb: 10,
      disabled: dropFileDisabled,
      onSuccess: onAcceptFile,
      onError: onRejectFile
    }),
    title: I18n.t("Inventory file")
  });
}
let CatalogInventoryImportFileCard = {
  styles: styles,
  make: CatalogInventoryImportPage$CatalogInventoryImportFileCard
};
function CatalogInventoryImportPage$CatalogInventoryImportDatetimeCard(props) {
  let state = props.state;
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx(Tooltip.make, {
        children: JsxRuntime.jsx(InputToggleSwitchField.make, {
          label: I18n.t("Import at an earlier datetime"),
          required: false,
          value: state.enabled,
          onChange: props.onToggle
        }),
        placement: "end",
        offset: 3,
        content: JsxRuntime.jsx(Tooltip.Span.make, {
          text: I18n.t("To view inventory movements following a backdated inventory, filter the movement table by the previous date entered.")
        }),
        delay: 350,
        closeDelay: 0
      }), state.enabled ? JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(InputDateField.make, {
          label: I18n.t("Date"),
          disabledFutureDays: true,
          value: state.value,
          onChange: props.onDateChange
        }), JsxRuntime.jsx(InputTimeField.make, {
          label: I18n.t("Time"),
          required: true,
          errorMessage: state.errorMessage,
          value: undefined,
          onChange: props.onDatetimeChange
        })],
        space: "medium"
      }) : JsxRuntime.jsxs(InlineText.make, {
        children: [JsxRuntime.jsx(TextStyle.make, {
          children: I18n.t("By default, inventory is imported at time"),
          variation: "normal",
          size: "small"
        }), JsxRuntime.jsx(TextStyle.make, {
          children: " t.",
          variation: "subdued",
          size: "small"
        })]
      })],
      space: "medium"
    }),
    title: I18n.t("Import option"),
    grow: true
  });
}
let CatalogInventoryImportDatetimeCard = {
  make: CatalogInventoryImportPage$CatalogInventoryImportDatetimeCard
};
let text = `Please be aware that the action of importing inventory is irreversible. Before launching the import of the loaded file, make sure you have taken all the necessary precautions:

1. You have verified that you've entered accurate stock quantities in your import file.
2. You have checked that the inventory date for your file corresponds to the import options defined in the interface.
3. You have synchronized all of the store's iPads, and then you have not made any further stock movements on the devices until the inventory has been imported.`;
function CatalogInventoryImportPage$CatalogInventoryImportPrecautionCard(props) {
  return JsxRuntime.jsxs(Card.make, {
    children: [JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t(text)
    }), JsxRuntime.jsx(TextAction.make, {
      text: I18n.t("Consult the tutorial dedicated to inventory import"),
      highlighted: true,
      onPress: () => HelpCenter.showArticle(HelpCenter.prepareImportInventory)
    })],
    title: I18n.t("Read precautions before importing"),
    grow: true
  });
}
let CatalogInventoryImportPrecautionCard = {
  text: text,
  make: CatalogInventoryImportPage$CatalogInventoryImportPrecautionCard
};
function arrayChunks(value, size) {
  if (value.length !== 0) {
    if (size > 0) {
      return Stdlib_Array.fromInitializer(Stdlib_Math.Int.ceil(value.length / size), index => value.slice(index * size | 0, (index * size | 0) + size | 0));
    } else {
      return [value];
    }
  } else {
    return [];
  }
}
function queryCatalogInventoryImport(catalogInventoryImportRequest, catalogInventoryQueryChunkSize, inventoryItems, inventoryDatetime, param) {
  return Future.map(Future.all(arrayChunks(inventoryItems, catalogInventoryQueryChunkSize).map(inventoryItems => catalogInventoryImportRequest(inventoryItems, inventoryDatetime))), undefined, results => {
    if (results.every(Stdlib_Result.isOk)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: undefined
      };
    }
  });
}
function queryCatalogInventoryAudit(catalogInventoryAuditRequest, catalogInventoryQueryChunkSize, inventoryItems) {
  return Future.map(Future.all(arrayChunks(inventoryItems, catalogInventoryQueryChunkSize).map(inventoryItems => catalogInventoryAuditRequest(inventoryItems))), undefined, results => {
    if (results.every(Stdlib_Result.isOk)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let errors = Stdlib_Array.reduce(results, [], (acc, result) => {
      if (result.TAG === "Ok") {
        return acc;
      } else {
        return Belt_Array.concatMany([acc, result._0]);
      }
    });
    return {
      TAG: "Error",
      _0: errors
    };
  });
}
function mapQueryCatalogInventorySheetDecodeRowError(errors) {
  let traceFromRowError = (json, index) => {
    let values = {
      json: Json.stringify(json),
      index: (index + 1 | 0).toString()
    };
    let stringLiteral = I18n.t("{{json}} at line {{index}}");
    return I18n.template(stringLiteral, Primitive_option.some(values), undefined);
  };
  return errors.map(error => {
    switch (error.TAG) {
      case "CannotDecodeHeaderRow":
      case "CannotDecodeRow":
        break;
      case "CannotDecodeCellVariantId":
        let trace = traceFromRowError(error.json, error.index);
        let stringLiteral = I18n.t("Incorrect reference ID {{trace}}");
        return I18n.template(stringLiteral, {
          trace: trace
        }, undefined);
      case "CannotDecodeCellStock":
        let trace$1 = traceFromRowError(error.json, error.index);
        let stringLiteral$1 = I18n.t("Incorrect inventory quantity {{trace}}");
        return I18n.template(stringLiteral$1, {
          trace: trace$1
        }, undefined);
      case "NegativeCellStock":
        let trace$2 = traceFromRowError(error.json, error.index);
        let stringLiteral$2 = I18n.t("Negative inventory quantity {{trace}}");
        return I18n.template(stringLiteral$2, {
          trace: trace$2
        }, undefined);
      case "EmptyCellStock":
        let stringLiteral$3 = I18n.t("Inventory quantity missing at line {{line}}");
        return I18n.template(stringLiteral$3, {
          line: error.index + 1 | 0
        }, undefined);
      case "EmptyCellVariantId":
        let stringLiteral$4 = I18n.t("Reference ID missing at line {{line}}");
        return I18n.template(stringLiteral$4, {
          line: error.index + 1 | 0
        }, undefined);
    }
    let trace$3 = traceFromRowError(error.json, error.index);
    let stringLiteral$5 = I18n.t("Cannot decode {{trace}}");
    return I18n.template(stringLiteral$5, {
      trace: trace$3
    }, undefined);
  });
}
function mapQueryCatalogInventorySheetParseAndDecodeError(error) {
  switch (error) {
    case "InvalidHeaderRow":
      let message = I18n.t("Please ensure that the inventory file is correct. Errors have been identified on the header row: the columns '{{A}}' and/or '{{B}}' cannot be found.");
      return I18n.template(I18n.t(message), {
        A: CatalogInventoryImportSheet.dictVariantIdKey,
        B: CatalogInventoryImportSheet.dictStockKey
      }, undefined);
    case "NoRows":
      return I18n.t("Please ensure that the inventory file is correct: it is currently empty, no rows have been found.");
    case "EmptyColumnStock":
      return I18n.template(I18n.t("Please ensure that the inventory file is correct, the '{{column}}' column is empty."), {
        column: CatalogInventoryImportSheet.dictStockKey
      }, undefined);
    case "Unknown":
      return I18n.t("Please ensure that the inventory file is correct, as an error has been reported during its analysis.");
  }
}
function mapQueryCatalogInventoryAuditError(error, headerOffset, inventoryItems) {
  let formateErrorMessage = (variantId, errorMessageTemplate, errorMessageTemplateTrace) => {
    let index = Stdlib_Array.findIndexOpt(inventoryItems, param => param.variantId === variantId);
    if (index === undefined) {
      return;
    }
    let traceValues = {
      json: Json.stringify(Json.encodeString(variantId)),
      index: ((index + 1 | 0) + headerOffset | 0).toString()
    };
    let trace = I18n.template(errorMessageTemplateTrace, Primitive_option.some(traceValues), undefined);
    return I18n.template(errorMessageTemplate, {
      trace: trace
    }, undefined);
  };
  let mappedErrors = Stdlib_Array.filterMap(error, error => {
    if (typeof error !== "object") {
      return;
    }
    switch (error.TAG) {
      case "NotFoundVariant":
        let errorMessageTemplateTrace = I18n.t("{{json}} at line {{index}}");
        let errorMessageTemplate = I18n.t("Incorrect reference ID {{trace}}");
        return formateErrorMessage(error._0, errorMessageTemplate, errorMessageTemplateTrace);
      case "InvalidCapacityPrecision":
        let errorMessageTemplateTrace$1 = I18n.t("at line {{index}}");
        let errorMessageTemplate$1 = I18n.t("Incorrect or corrupted inventory quantity at decimals {{trace}}, please re-enter the value.");
        return formateErrorMessage(error._0, errorMessageTemplate$1, errorMessageTemplateTrace$1);
      case "NotBulkProduct":
        let errorMessageTemplateTrace$2 = I18n.t("at line {{index}}");
        let errorMessageTemplate$2 = I18n.t("Invalid product inventory quantity {{trace}}, product is unit and its quantity must be an integer.");
        return formateErrorMessage(error._0, errorMessageTemplate$2, errorMessageTemplateTrace$2);
      case "DuplicateVariantId":
        let errorMessageTemplateTrace$3 = I18n.t("{{json}} at line {{index}}");
        let errorMessageTemplate$3 = I18n.t("several occurrences of the ID {{trace}} are present in the file.");
        return formateErrorMessage(error._0, errorMessageTemplate$3, errorMessageTemplateTrace$3);
      case "OutOfRangeStockValue":
        let errorMessageTemplateTrace$4 = I18n.t("at line {{index}}");
        let errorMessageTemplate$4 = I18n.t("Incorrect inventory quantity {{trace}}");
        return formateErrorMessage(error._0, errorMessageTemplate$4, errorMessageTemplateTrace$4);
    }
  });
  if (mappedErrors.length === 0) {
    return;
  } else {
    return mappedErrors;
  }
}
function catalogInventoryImportRequest(inventoryItems, inventoryDatetime) {
  return make$1(inventoryItems, inventoryDatetime, undefined);
}
let catalogInventoryAuditRequest = make;
function catalogInventoryProcessAudit(value, file, dispatch) {
  Future.map(Future.flatMapOk(Future.flatMap(value, undefined, param => {
    let payload = param.payload;
    let tmp;
    if (payload.TAG === "Ok") {
      let rows = payload._0;
      let okRows = Stdlib_Array.filterMap(rows, row => {
        if (row.TAG !== "Ok") {
          return;
        }
        let row$1 = row._0;
        let sanitizedStock = row$1.stock.toFixed(3);
        let stock = Stdlib_Option.getOr(Stdlib_Float.fromString(sanitizedStock), row$1.stock);
        return {
          variantId: row$1.variantId,
          stock: stock
        };
      });
      let erroredRows = Stdlib_Array.filterMap(rows, row => {
        if (row.TAG === "Ok") {
          return;
        } else {
          return row._0;
        }
      });
      tmp = erroredRows.length !== 0 ? {
        TAG: "Error",
        _0: {
          TAG: "MultipleParseDecodeErrors",
          _0: mapQueryCatalogInventorySheetDecodeRowError(erroredRows)
        }
      } : {
        TAG: "Ok",
        _0: {
          headerOffset: param.headerOffset,
          payload: okRows
        }
      };
    } else {
      let parseDecodeError = mapQueryCatalogInventorySheetParseAndDecodeError(payload._0);
      tmp = {
        TAG: "Error",
        _0: {
          TAG: "ParseDecodeError",
          _0: parseDecodeError
        }
      };
    }
    return Future.value(tmp);
  }), undefined, param => {
    let inventoryItems = param.payload;
    let headerOffset = param.headerOffset;
    return Future.mapError(Future.mapOk(queryCatalogInventoryAudit(catalogInventoryAuditRequest, 2500, inventoryItems), undefined, () => ({
      filename: file.name,
      data: inventoryItems
    })), undefined, error => {
      let maybeErrorMessage = mapQueryCatalogInventoryAuditError(error, headerOffset, inventoryItems);
      if (maybeErrorMessage !== undefined) {
        return {
          TAG: "ServerError",
          _0: {
            TAG: "ErrorMessages",
            _0: maybeErrorMessage
          }
        };
      } else {
        return {
          TAG: "ServerError",
          _0: "Unexpected"
        };
      }
    });
  }), undefined, data => dispatch({
    TAG: "SetFileProcessed",
    _0: {
      TAG: "Audit",
      _0: {
        TAG: "Done",
        _0: data
      }
    }
  }));
}
function CatalogInventoryImportPage(props) {
  let match = ReactUpdateReducer.use(reducer, initialState$2);
  let dispatch = match[1];
  let state = match[0];
  React.useEffect(() => {
    let match = state.submitted;
    let match$1 = state.errored;
    let match$2 = state.sheetFile;
    if (match && !match$1 && match$2 !== undefined) {
      let inventoryItems = match$2.data;
      let filename = match$2.filename;
      Future.get(queryCatalogInventoryImport(catalogInventoryImportRequest, 2500, inventoryItems, state.datetimeState.value, undefined), result => {
        if (result.TAG === "Ok") {
          return dispatch({
            TAG: "SetFileProcessed",
            _0: {
              TAG: "Import",
              _0: {
                TAG: "Done",
                _0: {
                  TAG: "Ok",
                  _0: {
                    filename: filename,
                    data: inventoryItems
                  }
                }
              }
            }
          });
        } else {
          return dispatch({
            TAG: "SetFileProcessed",
            _0: {
              TAG: "Import",
              _0: {
                TAG: "Done",
                _0: {
                  TAG: "Error",
                  _0: undefined
                }
              }
            }
          });
        }
      });
    }
  }, [state.submitted]);
  let onAcceptFile = file => {
    dispatch({
      TAG: "SetFileProcessed",
      _0: {
        TAG: "Audit",
        _0: "Loading"
      }
    });
    let match = FilePicker.typeFromMime(file.type);
    if (match.TAG !== "Ok") {
      return;
    }
    let match$1 = match._0;
    if (match$1 === "spreadsheetml") {
      return catalogInventoryProcessAudit(CatalogInventoryImportSheet.parseAndDecodeXlsxFile(2, file), file, dispatch);
    } else if (match$1 === "csv") {
      return catalogInventoryProcessAudit(CatalogInventoryImportSheet.parseAndDecodeCsvFile(file), file, dispatch);
    } else {
      return;
    }
  };
  let onRejectFile = message => dispatch({
    TAG: "SetNotificationRequested",
    _0: {
      textStatus: {
        TAG: "Danger",
        _0: message
      }
    }
  });
  let onToggleBackdateView = enabled => dispatch({
    TAG: "BackdateToggled",
    _0: enabled
  });
  let onDateChange = date => dispatch({
    TAG: "DateUpdated",
    _0: date
  });
  let onDatetimeChange = datetime => dispatch({
    TAG: "DatetimeUpdated",
    _0: datetime
  });
  let onReset = () => dispatch("ResetRequested");
  let onClearNotification = () => dispatch({
    TAG: "SetNotificationRequested",
    _0: undefined
  });
  let status = state.fileState;
  let pageActions;
  if (status.TAG === "Audit") {
    let match$1 = status._0;
    if (typeof match$1 !== "object" || match$1.TAG !== "Done") {
      pageActions = null;
    } else {
      let match$2 = match$1._0;
      if (match$2.TAG === "Ok") {
        let match$3 = match$2._0;
        let data = match$3.data;
        let filename = match$3.filename;
        pageActions = JsxRuntime.jsx(Button.make, {
          label: I18n.t("Launch import"),
          variant: "solid",
          tone: "brand",
          onPress: () => dispatch({
            TAG: "ImportSubmitted",
            _0: {
              filename: filename,
              data: data
            }
          })
        });
      } else {
        pageActions = null;
      }
    }
  } else {
    let status$1 = status._0;
    pageActions = AsyncResult.isBusy(status$1) ? JsxRuntime.jsx(Button.make, {
      label: I18n.t("Launch import"),
      variant: "solid",
      tone: "brand",
      pending: true
    }) : typeof status$1 !== "object" || status$1.TAG !== "Done" || status$1._0.TAG !== "Ok" ? null : JsxRuntime.jsx(Button.make, {
      label: I18n.t("Load new inventory"),
      onPress: () => dispatch("ResetRequested")
    });
  }
  let shouldBlockOnRouteChange = React.useCallback(_nextRoute => {
    let match = state.fileState;
    if (match.TAG === "Audit") {
      return false;
    }
    let tmp = match._0;
    if (typeof tmp !== "object") {
      return tmp === "Loading";
    } else {
      return false;
    }
  }, [state.fileState]);
  let match$4 = state.fileState;
  let formattedTitle;
  if (match$4.TAG === "Audit") {
    let tmp = match$4._0;
    formattedTitle = typeof tmp !== "object" || tmp.TAG !== "Done" ? I18n.t("Step 1 | Validate the inventory file") : I18n.t("Step 2 | Import the inventory file");
  } else {
    let tmp$1 = match$4._0;
    formattedTitle = typeof tmp$1 !== "object" || tmp$1.TAG !== "Done" ? I18n.t("Step 2 | Import the inventory file") : I18n.t("Import finished");
  }
  let match$5 = state.notification;
  return JsxRuntime.jsxs(Page.make, {
    children: [JsxRuntime.jsx(Navigation.Prompt.make, {
      message: I18n.t("Warning: the inventory import operation is still in progress."),
      shouldBlockOnRouteChange: shouldBlockOnRouteChange
    }), match$5 !== undefined ? JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Banner.make, {
        textStatus: match$5.textStatus,
        details: match$5.details,
        onRequestClose: onClearNotification
      }),
      spaceTop: "medium"
    }) : null, JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsxs(Stack.make, {
        children: [JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportFileCard, {
          state: state.fileState,
          sheetFile: state.sheetFile,
          onAcceptFile: onAcceptFile,
          onRejectFile: onRejectFile,
          onResetPress: onReset
        }), JsxRuntime.jsxs(Group.make, {
          children: [JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportDatetimeCard, {
            state: state.datetimeState,
            onToggle: onToggleBackdateView,
            onDateChange: onDateChange,
            onDatetimeChange: onDatetimeChange
          }), JsxRuntime.jsx(CatalogInventoryImportPage$CatalogInventoryImportPrecautionCard, {})],
          grid: ["30%", "70%"],
          wrap: false,
          spaceX: "medium"
        })],
        space: "medium"
      }),
      spaceTop: "large"
    })],
    title: formattedTitle,
    renderActions: () => pageActions
  });
}
let make$2 = React.memo(CatalogInventoryImportPage);
let catalogInventoryQueryChunkSize = 2500;
let dictVariantIdKey = CatalogInventoryImportSheet.dictVariantIdKey;
let dictStockKey = CatalogInventoryImportSheet.dictStockKey;
export { CatalogInventoryAuditRequest, CatalogInventoryImportRequest, CatalogInventoryImportPickFileView, CatalogInventoryImportLaunchImportView, CatalogInventoryImportSuccessImportView, CatalogInventoryImportFileState, CatalogInventoryImportDatetimeState, CatalogInventoryImportReducer, CatalogInventoryImportFileCard, CatalogInventoryImportDatetimeCard, CatalogInventoryImportPrecautionCard, arrayChunks, catalogInventoryQueryChunkSize, queryCatalogInventoryImport, queryCatalogInventoryAudit, dictVariantIdKey, dictStockKey, mapQueryCatalogInventorySheetDecodeRowError, mapQueryCatalogInventorySheetParseAndDecodeError, mapQueryCatalogInventoryAuditError, catalogInventoryImportRequest, catalogInventoryAuditRequest, catalogInventoryProcessAudit, make$2 as make };
/* endpoint Not a pure module */